import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getLocations({ cursor = '', limit = '', q = '', status = '' } = {}) {
    const params = {
      cursor,
      limit,
      q,
      status,
    };
    return api.get('/locations', { params: omitBy(params, isNil) });
  },
  getLocation(id) {
    return api.get(`/locations/${id}`);
  },
  createLocation(location = {}) {
    return api.post('/locations', location);
  },
  updateLocation(id, location = {}) {
    return api.put(`/locations/${id}`, location);
  },
  activateLocation(id) {
    return api.put(`/locations/${id}/reactivate`);
  },
  deactivateLocation(id) {
    return api.delete(`/locations/${id}`);
  },
  deleteLocation(id) {
    return api.delete(`/locations/${id}/delete`);
  },
};
